<template>
  <div class="app-container">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {
  }
}
</script>

<style>
.navbar {
  display: flex;
  justify-content: space-between;
}
</style>
